import { defineStore } from 'pinia'

export const useSessionStore = defineStore('SessionStore', {
  state: () => ({
    patientId: null as string | null,
    jwt: null as string | null
  }),

  actions: {
    setSessionData(patientId: string, jwt: string) {
      this.patientId = patientId
      this.jwt = jwt
    }
  },

  getters: {
    getPatientId(state) {
      return state.patientId
    },
    getJwt(state) {
      return state.jwt
    }
  }
})
